<template>
  <div>
    <div class="row col-md-12">
      <div class="card card-siak">

        <div class="d-flex justify-content-between align-items-center">
          <div class="title">
            <h1>Edit Komponen Penilaian - DIKMATRA</h1>
          </div>
        </div>

        <KTCodePreview>
          <template v-slot:preview>
            <v-card>
              <v-card-title></v-card-title>
              <b-form>

                <div class="row align-items-center">
                  <div class="col-sm-2 mb-4">
                    <span>Prodi</span>
                  </div>
                  <div class="col-sm-6">
                    <b-form-group>
                        <Select2 :options="prodiOptions"
                        :settings="{ settingOption: value, multiple: false, width: '100%' }" />
                    </b-form-group>
                  </div>
                </div>

                <div class="row align-items-center">
                  <div class="col-sm-2 mb-4">
                    <span>Matakuliah</span>
                  </div>
                  <div class="col-sm-6">
                    <b-form-group>
                      <b-form-input id="tambahMataKuliah" type="text" required></b-form-input>
                    </b-form-group>
                  </div>
                </div>

                <div class="row align-items-center">
                  <div class="col-sm-2 mb-4">
                    <span>SKS</span>
                  </div>
                  <div class="col-sm-6">
                    <b-form-group>
                      <b-form-input id="tambahSks" type="text" required></b-form-input>
                    </b-form-group>
                  </div>
                </div>

                <div class="d-flex justify-content-between align-items-center">
                  <button type="button" class="btn-blue-sub" @click="addRow" style="z-index: 1;">
                    <b-icon icon="plus-circle" scale="1" variant="default"></b-icon>&nbsp;Tambah Sub
                  </button>
                </div>
                <div class="mt-3">
                  <table style="width:100%;">
                    <thead>
                      <tr>
                        <th style="background-color: #3751E4; color: white"><center>Komponen Nilai</center></th>
                        <th style="background-color: #3751E4; color: white"><center>Bobot Komponen</center></th>
                        <th style="background-color: #3751E4; color: white"><center>Sub Komponen</center></th>
                        <th style="background-color: #3751E4; color: white"><center>Sub-Action</center></th>
                        <th style="background-color: #3751E4; color: white"><center>Aksi</center></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(tableData, index) in tableRows" :key="index" :id="'row_'+index">
                        <td><center><b-form-input id="input1" type="text" required style="width: 205px; height: 22px; border-radius: 5px;"></b-form-input></center></td>
                        <td><center><b-form-input id="input2" type="text" required style="width: 205px; height: 22px; border-radius: 5px;"></b-form-input></center></td>
                        <td><center><b-form-input id="input3" type="text" required style="width: 205px; height: 22px; border-radius: 5px;"></b-form-input></center></td>
                        <td>
                          <center>
                            <button type="button" class="btn-blue-sub" style="z-index: 1;">
                              <b-icon icon="plus-circle" scale="1" variant="default"></b-icon>&nbsp;Tambah Sub
                            </button>
                          </center>
                        </td>
                        <td style="padding: 5px;">
                          <center>
                            <button @click="deleteRow(tableData)" type="button" style="background-color: #EF4848; color: white; height: 30px; width: 30px; min-width: 30px; border-radius: 5px;">
                              <i class="fa fa-trash" style="color: white;"></i>
                            </button>
                          </center>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="row mt-5">
                  <div class="col-lg-6"><!-- empty space for div --></div>
                  <div class="col-lg-6" style="display: flex;">
                    <b-button type="submit" variant="primary" style="margin-left: auto;">Simpan</b-button>
                    <router-link to="/penilaian-siswa/komponen-nilai" v-slot="{ navigate }">
                      <button @click="navigate" role="link">
                        <b-button type="reset" variant="danger" class="ml-2" style="margin-left: auto;">Batal</b-button>
                      </button>
                    </router-link>
                  </div>
                </div>
              </b-form>
            </v-card>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script type="module">
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import KTCodePreview from "@/view/content/CodePreview.vue";
import Select2 from 'v-select2-component';

export default {
  data() {
    return {
      selected: null,
      prodiOptions: [
        { id: 'a', text: 'DIKREG' },
        { id: 'b', text: 'DIKMATRA' },
        { id: 'c', text: 'SUSJEMESTRA' }
      ],
      tableRows: ["row_0"],
      counter: 0
    }
  },
  components: {
    KTCodePreview,
    Select2
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Penilaian Siswa" },
      { title: "Komponen Nilai" }
    ]);
  },
  methods: {
    addRow() {
      this.counter++;
      this.tableRows.push("row_" + this.counter);
    },
    deleteRow(tableData) {
      var element = document.getElementById(tableData);
      element.parentNode.removeChild(element);
    },
  }
}
</script>
